/**
 * Cadastro público (CERES-ACC-005): o que as telas compartilham.
 *
 * O token de CONTINUAÇÃO fica no `sessionStorage` da aba — some ao fechá-la,
 * e a retomada é por e-mail e senha. Ele não é sessão do CRM: só alcança as
 * etapas do próprio cadastro, e o servidor o recusa depois de 24 horas.
 */

const CHAVE = 'ceres.cadastro.continuacao';

export function lerContinuacao(): string | null {
  try {
    return sessionStorage.getItem(CHAVE);
  } catch {
    return null;
  }
}

export function guardarContinuacao(token: string): void {
  try {
    sessionStorage.setItem(CHAVE, token);
  } catch {
    // Sem armazenamento (aba privada restrita): a retomada por e-mail e senha cobre.
  }
}

export function esquecerContinuacao(): void {
  try {
    sessionStorage.removeItem(CHAVE);
  } catch {
    // idem
  }
}

/** Troca `{chave}` pelos valores — os textos do i18n não interpolam sozinhos. */
export function preencher(texto: string, valores: Record<string, string | number>): string {
  return texto.replace(/\{(\w+)\}/g, (_m, chave: string) => String(valores[chave] ?? ''));
}

export interface Continuacao {
  continuacao: string;
  nome: string;
  email: string;
  validaAte: string;
}

export interface ResultadoDaConclusao {
  email: string;
  organizacao: { nome: string };
  assinatura: {
    plano: string;
    situacao: 'TRIAL' | 'PENDING' | 'ACTIVE' | 'OUTRA';
    avaliacaoAte: string | null;
  };
}

export interface ModalidadeDoPlano {
  codigo: string;
  nome: string;
  descricao: string | null;
  versao: number;
  funcionalidades: string[];
  limiteDeUsuarios: number | null;
  preco: { valorMensalPorUsuarioEmCentavos: string; moeda: string } | null;
  modalidade:
    | { tipo: 'AVALIACAO_GRATUITA'; dias: number; limiteDeUsuarios: number }
    | { tipo: 'ATIVACAO_PELA_EQUIPE' };
}
